import { QueryClient } from '@tanstack/react-query';
import { Navigate } from 'react-router-dom';

import { prepopulateCache } from '$shared/utils/react-query.utils';

import {
  createGetFeatureToggleQuery,
  useGetFeatureToggle,
} from '$components/app-config/app-config.api';
import { OrganizationSettings } from '$features/organization-settings/organization-settings';
import { createGetOrganizationSettingsQuery } from '$features/subscription/organization-settings.api';

export async function organizationSettingsLoader(
  queryClient: QueryClient,
): Promise<null> {
  const flags = await queryClient.fetchQuery(createGetFeatureToggleQuery());
  if (!flags.includes('ESEVNLS_5086_ORGANIZATION_SETTINGS')) return null;

  return prepopulateCache(queryClient, createGetOrganizationSettingsQuery());
}

export function OrganizationSettingsPage() {
  const { data: flags, isPending } = useGetFeatureToggle();
  if (isPending) return null;
  const enabled = flags?.includes('ESEVNLS_5086_ORGANIZATION_SETTINGS');
  return enabled ? <OrganizationSettings /> : <Navigate to="/" replace />;
}
